const actions = {
  FETCH_CAMERA_STATUS_REPORTS: "FETCH_CAMERA_STATUS_REPORTS",
  LOAD_SITE_LIST: "LOAD_SITE_LIST"
};

export default actions;